module.exports = __webpack_public_path__ + "img/22.ae8c372c.png";